import { Tooltip } from "@mui/material";
import Column from "components/common/Column";
import Row from "components/common/Row";
import { Link } from "react-router-dom";
import { getMissionWorkFlowStatistics } from "helpers";
import { USER_ROLES } from "constants";
import { useSelector } from "react-redux";

const MissionTaskCards = ({ missionData, process, mission_process_counts, link, isDueDateExceeded, missionMovement = [], processess = [] }) => {
  const hasFlag = missionData?.country?.relationCountryFlag?.flag ? true : false;
  const defaultLink = link ? link : `/portal/mission-process/${missionData?.id}/create`;
  const { awaiting_complition, required_action } = getMissionWorkFlowStatistics(processess, missionMovement, missionData.mission_manager_id)
  const authData = useSelector(s => s.auth.data);
  return (
    <div className="col-md-4">
      <Link
        to={defaultLink}
        className="d-block text-center my-2 corner-rounded text-dark fw-bold py-6 px-10 w-100 shadow-sm bg-light-beige"
      >
        <div className="d-flex justify-content-between my-2">
          <span className="text-uppercase text-danger fs-4">{missionData?.country_name}</span>
          {
            isDueDateExceeded &&
            <div className="h-auto">
              <Tooltip
                title="This mission has an active form/task requiring your attention."
                placement="top"
                arrow
                componentsProps={{
                  tooltip: {
                    sx: {
                      backgroundColor: '#fff',
                      borderRadius: 2,
                      padding: '10px 10px',
                      color: '#000',
                      fontWeight: '400',
                      fontSize: '14px',
                      border: '1px solid #ccc'
                    },
                  },
                }}
              >
                <i
                  className="fa-solid fa-triangle-exclamation text-danger fs-1"
                ></i>
              </Tooltip>
            </div>
          }
        </div>
        <div className="d-flex my-4">
          <span className="me-1 px-4 py-2 fst-italic timeline-green bg-timeline-green rounded">{missionData?.mission_sector}</span>
          <span className="mx-1 px-4 py-2 fst-italic light-blue bg-light rounded">{missionData?.activity_type?.name}</span>
          <span className="d-flex py-2"> {
            missionData?.relationMissionSpecificMapping?.map((item, index) => {
              return (
                <div key={index}>
                  <span className="mx-1 px-2 py-2 fst-italic light-yellow bg-light-yellow rounded">{item?.relationSpecificContent?.list_element_name}</span>
                </div>
              );
            })
          }</span>

        </div>
        {/* <div className="">
        {
            missionData?.relationMissionSpecificMapping?.map((item, index) => {
              return (
                <div key={index}>
                  <span className="mx-1 px-4 py-2 fst-italic light-yellow bg-light-yellow rounded">{item?.relationSpecificContent?.list_element_name}</span>
                </div>
              );
            })
          }
        </div> */}
        <Row className='my-3'>
          {
            hasFlag && (
              <Column className='mt-2' col={4}>
                <img
                  src={missionData?.country?.relationCountryFlag?.flag}
                  style={{
                    objectFit: 'contain',
                    width: '100%',
                  }}
                />
              </Column>
            )
          }
          <Column col={hasFlag ? 8 : 12} className='d-flex flex-column align-items-baseline'>
            <span className="text-start text-grey">{process?.name}</span>
            <div className="d-flex">
              {/* {USER_ROLES.delegate.includes(authData?.role_id) && (<>
              </>)} */}
              {missionData?.mission_manager_id === null ? (<></>) : (
                <span className="me-1 text-grey">
                  {awaiting_complition.count + required_action.count}
                </span>
              )}

              <span className="text-start text-grey d-flex">{missionData?.mission_manager_id === null ? "Pending Review" : "Active Forms"}</span>
            </div>
            {
              mission_process_counts && mission_process_counts?.total_process && (
                <>
                  <span className="text-start text-grey">
                    {mission_process_counts?.completed_process}/{mission_process_counts?.total_process} Tasks ({parseInt((mission_process_counts?.completed_process / mission_process_counts?.total_process) * 100)}% Completed)
                  </span>
                </>
              )
            }
            <span className="text-start text-grey"> Mission Manager: {missionData?.relationMissionManager?.name}</span>

          </Column>
        </Row>
      </Link>
    </div>
  );
};

MissionTaskCards.defaultProps = {
  missionData: [],
  process: {},
  mission_process_counts: {},
  isDueDateExceeded: false,
};

export default MissionTaskCards;
